export const MAX_QUANTITY_INPUT_NUMBER = 99;
